import React, { useState, useEffect, useRef, useContext } from "react";
import { AppContext } from "../AppContext";
import crossIcon from "../assets/crossIcon.png";
// import { fetchContent } from "../services/api";
import { Translate } from "./LanguageChanger";
import Wrapper from "./shared/Wrapper";
import { userLoginSignup } from "../services/services";
import { sendTestMatomoEvent } from "../Analytics/MatomoManager/matomoTest";
import CustomButton from "./CustomButton";
import { analytics, logEvent } from "./firebase";  

let OTP = "";

const OtpVerification = ({ navigate, handleLeft, isExpired }) => {
  const [otp, setOtp] = useState(["", "", "", "", "", ""]);
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [resendEnabled, setResendEnabled] = useState(false);
  const [timer, setTimer] = useState(60);
  const [isOtpScreen, setIsOtpScreen] = useState(false);
  const [isLoginScreen, setIsLoginScreen] = useState(true);
  const [errorMessage, setErrorMessage] = useState("");
  const { isLogedIn, setIsLogedIn } = useContext(AppContext);

  const inputRefs = useRef([]);
  const keyboardRefs = useRef([]);
  const resendRef = useRef();

  useEffect(() => {
    // Start the timer countdown
    const countdown = setInterval(() => {
      setTimer((prev) => (prev > 0 ? prev - 1 : 0));
    }, 1000);

    // Enable resend when the timer reaches 0
    if (timer === 0) {
      clearInterval(countdown);
      setResendEnabled(true);
    }

    return () => clearInterval(countdown);
  }, [timer]);

  useEffect(() => {
    // console.log("testOtp")
    if (otp.every((digit) => digit !== "")) {
      setSelectedIndex(11);
      loadData();
      setIsLogedIn(true);
    }
  }, [otp]);

  const handleResendOtp = () => {
    setOtp(["", "", "", "", "", ""]); // Clear OTP inputs
    setResendEnabled(false); // Disable the resend button
    setTimer(60); // Reset the timer
    // keyboardRefs.current[0]?.focus(); // Set focus back to the first key

    let mobileNoValue = localStorage.getItem("mobileNo");
    sendTestMatomoEvent({
      eventCategory: "Login",
      eventAction: "ResendOtp",
      eventName: `${mobileNoValue}`,
    });
    setSelectedIndex(0);
    keyboardRefs.current[selectedIndex]?.focus();
    setErrorMessage("");
    loadData();
  };

  useEffect(() => {
    // Set focus to the first number in the keyboard by default
    keyboardRefs.current[0]?.focus();
  }, []);

  const handleKeyboardNavigation = (e, index) => {
    // e.preventDefault();

    if (resendEnabled && index >= 9 && e.keyCode === 40) {
      // Down arrow navigation from Backspace, 0, Done to Resend link
      keyboardRefs.current[selectedIndex]?.blur();
      setSelectedIndex(-1); // Deselect any key from the keyboard
      resendRef.current?.focus();
      return;
    }

    if (
      (e.keyCode >= 48 && e.keyCode <= 57) ||
      (e.keyCode >= 96 && e.keyCode <= 105)
    ) {
      const number = e.keyCode >= 96 ? e.keyCode - 96 : e.keyCode - 48;

      if (number >= 0 && number <= 9) {
        handleKeyPress(number === 0 ? 10 : number - 1);
        setSelectedIndex(number === 0 ? 10 : number - 1);
      }
    }

    switch (e.keyCode) {
      case 37: // Left Arrow
        // if(index === 0 && isExpired){
        //   setSelectedIndex(-1)
        //   handleLeft()
        //   break
        // }
        if (index > 0) setSelectedIndex((prev) => (prev - 1 + 12) % 12);
        break;
      case 39: // Right Arrow
        setSelectedIndex((prev) => (prev + 1) % 12);
        break;
      case 38: // Up Arrow
        // console.log("asdfg", resendEnabled);
        if (resendEnabled && document.activeElement === resendRef.current) {
          // console.log("111111111....");
          setSelectedIndex(9); // Move focus back to Backspace
          resendRef.current?.blur();
        } else if (index >= 3) {
          setSelectedIndex((prev) => (prev - 3 + 12) % 12);
        }
        break;
      case 40: // Down Arrow
        if (resendEnabled && index >= 9) {
          // If Resend is enabled and focus is on "Backspace", "0", or "Done"
          keyboardRefs.current[selectedIndex]?.blur(); // Blur the current focused key
          setSelectedIndex(12); // Deselect any key from the keyboard
          resendRef.current?.focus(); // Move focus to the Resend button
        } else if (index < 9) {
          // Regular down arrow navigation for other keys
          setSelectedIndex((prev) => (prev + 3) % 12);
        }
        break;
      case 13: // Enter
        // handleKeyPress(index);
        if (resendEnabled && document.activeElement) {
          // if (e.key === "Enter") {
          setOtp(["", "", "", "", "", ""]);
          handleResendOtp();
          // }
          // console.log("resend button....");
          // handleResendOtp();
        } else {
          // console.log("other key enter...");
          handleKeyPress(index);
        }
        break;
      case 461: // return key
        // navigate("LoginPage", {});
        // setIsLoginScreen(true);
        // setIsOtpScreen(false);
        // callBack("Back");
        break;
        setIsLoginScreen(true);
        setIsOtpScreen(false);
        break;
      case 10009:
        break;
      default:
        break;
    }
  };

  const resendEnabledButton = () => {
    keyboardRefs.current[selectedIndex]?.blur();
    setSelectedIndex(-1); // Deselect any key from the keyboard
    resendRef.current?.focus();
  };

  const handleKeyPress = (index) => {
    setSelectedIndex(index);
    setOtp((prevOtp) => {
      const otpCopy = [...prevOtp];
      let inserted = false;

      

      // Handle input for numbers from 0 to 8
      if (index < 9) {
        for (let i = 0; i < otpCopy.length; i++) {
          if (otpCopy[i] === "") {
            otpCopy[i] = (index + 1).toString();
            inserted = true;
            break;
          }
        }
      }

      // Handle backspace (index 9)
      else if (index === 9) {
        for (let i = otpCopy.length - 1; i >= 0; i--) {
          if (otpCopy[i] !== "") {
            otpCopy[i] = "";
            inserted = true;
            break;
          }
        }
      }

      // Handle "0" input (index 10)
      else if (index === 10) {
        for (let i = 0; i < otpCopy.length; i++) {
          if (otpCopy[i] === "") {
            otpCopy[i] = "0";
            inserted = true;
            break;
          }
        }
      } else if (index === 11) {
        // Handle "Done" button press
        // alert(`OTP Entered: ${otp.join("")}`);
        const otpBoxes = document.querySelectorAll(".otp-box");
        const emptyfield = `${otp.join("")}`;
        if (emptyfield === "") {
          // Select all OTP box elements

          // Loop through each OTP box and set the red border
          otpBoxes.forEach((box) => {
            box.style.border = "2px solid #EC008C";
            setErrorMessage("enter otp");
            setTimeout(() => {
              setErrorMessage("");
              otpBoxes.forEach((box) => {
                box.style.border = "1px solid rgba(255, 255, 255, 1)"; // Reset to original border color
              });
            }, 10000);
          });
        } else {
          setErrorMessage(""); // Clear any error message
          loadData();
          setIsLogedIn(true);
        }
      }
      // Only update OTP state if something was inserted
      if (inserted) {
        setErrorMessage(""); // Reset error message on valid input
      }
      return otpCopy;
    });
  };

  const handleKeyDownOTP = (e) => {
    // read both series of numerical keys and if the key is not a number, prevent default

    console.log("reached otp handler");

    if (e.keyCode >= 48 && e.keyCode <= 57) {
      handleKeyPress(e.keyCode - 48);
    }

    if (e.keyCode >= 96 && e.keyCode <= 105) {
      handleKeyPress(e.keyCode - 96);
    }

    // handle backspace
    if (e.keyCode === 8) {
      handleKeyPress(9);
    }

    // handle done
    if (e.keyCode === 13) {
      handleKeyPress(11);
    }
  };

  const loadData = async () => {
    const myHeaders = {
      Version: localStorage.getItem("firmVersion"),
      Deviceid: localStorage.getItem("macAddress"),
      Devicetoken: localStorage.getItem("uuid"),
      Devicemodel: localStorage.getItem("productInfo"),

      "Content-Type": "application/json",
    };

    if (selectedIndex === 12) OTP = setOtp(["", "", "", "", "", ""]);
    else OTP = `${otp.join("")}`;

    const raw = {
      mobile: localStorage.getItem("mobileNo"),
      country_code: "+91",
      // otp: localStorage.getItem("getOTP"),
      otp: OTP,
    };

    // const requestOptions = {
    //   method: "POST",
    //   headers: myHeaders,
    //   body: JSON.stringify(raw),
    // };

    const body = JSON.stringify(raw);

    try {
      // const [response] = await Promise.all([
      //   fetchContent(
      //     "/V1/userLoginSignup",
      //     "POST",
      //     myHeaders,
      //     body,
      //     true
      //     // JSON.stringify(raw),
      //     // requestOptions
      //   ),
      // ]);

      const response = await userLoginSignup(JSON.stringify(raw));

      console.log("response...11", response);
      // const response = await fetchContent(
      //   "/V1/userLoginSignup",
      //   requestOptions
      // );
      // if (response.status === true) {
      //   localStorage.setItem("JWTToken", response.data.jwt);
      //   localStorage.setItem(
      //     "user_details",
      //     JSON.stringify(response.data.user_details)
      //   );
      //   navigate("WhoWatching", {});
      // } else {
      //   setTimeout(() => {
      //     setErrorMessage("");
      //   }, 10000);
      // }
      // if (!response.ok) {
      //   throw new Error(`HTTP error! status: ${response.status}`);
      // }
      // const result = await response.json();

      

      if (response.message && response.status !== true ) {
        setErrorMessage(response.message)
        console.log("checking11444")
       localStorage.setItem("LoginScreen", "OtpPage");
        sendTestMatomoEvent({
          eventCategory: "Login",
          eventAction: "ErrorLog ",
          eventName: `(${response.message})/(${localStorage.getItem(
            "mobileNo"
          )})`,
        });

        // Hide the error message after 10 seconds
        setTimeout(() => {
          setErrorMessage("");
        }, 10000);

       
      }
      
      else if (response.messageCode === "108" && response.status === true) {
        console.log("response 310", response.data);
        if (response.data.jwt === "") {
          console.log("response 310", response.data.tokens);
          localStorage.setItem("JWTToken", response.data.tokens.access);
          localStorage.setItem("refresh", response.data.tokens.refresh);
        } else {
          localStorage.setItem("JWTToken", response.data.jwt);
        }
 localStorage.setItem("validity", response.data.tokens.validity);
          sendTestMatomoEvent({
            eventCategory:"SessionTimedOut",
            eventAction:"LoginToken",
            eventName:`${response.data.tokens.access}-${response.data.tokens.validity}`
          })
        localStorage.setItem(
          "user_details",
          JSON.stringify(response.data.user_details)
        );

        const IsMobileValue = localStorage.getItem("mobileNo");
        const isEmail = localStorage.getItem("isEmail") === "true";

        // Matomo Event
        sendTestMatomoEvent({
          eventCategory: `Login`,
          eventAction: `VerifiedOtp`,
          eventName: `${IsMobileValue}`,
          url: "login",
        });

        if (response.data.user_details.new_user === 1) {
          sendTestMatomoEvent({
            eventCategory: "Login",
            eventAction: "RegistrationSuccessful",
            eventName: isEmail ? "Email" : `Mobile(${IsMobileValue})`,
          });
        }

        // console.log("response login devices....",response, response.data.user_details.is_device_limit_exceeded);
        if (response.data.user_details.is_device_limit_exceeded) {
          // console.log("Device limit exceed....", response);
          localStorage.setItem("user_device_info_id", JSON.stringify(response));
          navigate("ManageDevices", {});
        } else {
          // console.log("CheckingProfileId", response?.data?.user_details?.user_profiles);
          console.log(response.data.user_details.new_user, "login result");
          if (response.data.user_details.new_user === 1) {
            // console.log(selectedElementIndex, profiles[selectedElementIndex]);
            localStorage.setItem(
              "myProfile",
              JSON.stringify(response?.data?.user_details?.user_profiles[0])
            );
            localStorage.setItem(
              "profileId",
              response?.data?.user_details?.user_profiles[0].profile_id
            );
            localStorage.setItem(
              "userId",
              response?.data?.user_details?.user_profiles[0].user_id
            );
            localStorage.setItem(
              "proImg",
              response?.data?.user_details?.user_profiles[0].profile
            );
               if (analytics) {
                logEvent(analytics, "registration_successful", {
                  method: "New Registration",
                  source: window.DEVICE_TYPE === "8" ? "LG":"Samsung",
                  app_version: window.APP_VERSION,
                  platform: "web",
                  device_info: navigator.userAgent,
                });
            } 
            navigate("HomePage", {});
          } else {
            navigate("WhoWatching", {});
          }
        }
        // const userData = localStorage.getItem("user_details");
        // MenuScreen.ReseTfocus(4);
        // navigate("WhoWatching", {});
        // navigate("HomePage", {});
        // navigate("MyProfile", {});
      } else if (response.messageCode === "105" && response.status === true) {
        setErrorMessage(response.message);

        setTimeout(() => {
          setErrorMessage("");
        }, 10000);
      }
    } catch (error) {
      sendTestMatomoEvent({
        eventCategory: "Login",
        eventAction: "ErrorLog ",
        eventName: `(${error.message})/(${localStorage.getItem("mobileNo")})`,
      });
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    const handleGlobalKeyDown = (e) =>
      handleKeyboardNavigation(e, selectedIndex);
    window.addEventListener("keydown", handleGlobalKeyDown);

    return () => {
      window.removeEventListener("keydown", handleGlobalKeyDown);
    };
  }, [selectedIndex]);

  useEffect(() => {
    // Set focus to the currently selected key
    if (selectedIndex >= 0 && selectedIndex < 12) {
      keyboardRefs.current[selectedIndex]?.focus();
    }
  }, [selectedIndex]);

  const isEmail = localStorage.getItem("isEmail") === "true";
  const isMobile = localStorage.getItem("isMobile") === "true";
  const mobileNo = localStorage.getItem("mobileNo");

  const handleMouseEnter = (index) => {
    setSelectedIndex(index);
  };

  return (
    <div className="otp-container">
      <h2>
        <Translate langKey={"OTP-Verification"} />
      </h2>
      {isEmail && (
        <p>
          <Translate langKey={"verification-code"} />{" "}
          <Translate langKey={"email_address"} /> &nbsp;
          {mobileNo}
        </p>
      )}
      {isMobile && (
        <p>
          <Translate langKey={"verification-code"} />{" "}
          <Translate langKey={"Phone-Number"} /> +91&nbsp;
          {mobileNo}
        </p>
      )}
      <div className="otp-inputs">
        {otp.map((digit, idx) => (
          <input
            key={idx}
            value={digit}
            className="otp-box"
            readOnly
            ref={(el) => (inputRefs.current[idx] = el)}
          />
        ))}
      </div>
      {errorMessage && <p className="error-message">{errorMessage}</p>}
      {/* Error message display */}
      <div className="keyboard">
        {[
          1,
          2,
          3,
          4,
          5,
          6,
          7,
          8,
          9,
          "Backspace",
          0,
          <Translate langKey={"done"} />,
        ].map((key, index) => (
          // <Wrapper>
          <Wrapper
            key={index}
            className={`key ${selectedIndex === index ? "focused" : ""}`}
            onClick={(e) => handleKeyPress(index)}
            onMouseEnter={() => handleMouseEnter(index)}
            // onKeyDown={(e) => handleKeyboardNavigation(e, index)}
            ref={(el) => (keyboardRefs.current[index] = el)}
            tabIndex={-1}
            style={{
              width: "15vh",
              height: "6vh",
              fontSize: "20px",
              color: "white",
              backgroundColor: selectedIndex === index ? "#EC008C" : "#0E1653",
              border: "none",
              cursor: "pointer",
              outline: "none",
              textAlign: "center",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            {key === "Backspace" ? (
              <img src={crossIcon} alt="Backspace Icon" />
            ) : (
              key
            )}
            {/* {key} */}
          </Wrapper>
          // </Wrapper>
        ))}
      </div>
      <div className="resend-otp">
        {resendEnabled ? (
          <div className="resend-section">
            <p>
              <Translate langKey={"didnt_receive_otp"} />?
            </p>
            {/* <CustomButton> */}
              <button
                ref={resendRef}
                className="resend-button"
                border={"none"}                
                style={{
                  color:
                    document.activeElement === resendRef.current
                      ? "#EC008C"
                      : "rgba(151, 151, 151, 1)",
                 
                }}
                  onMouseEnter={(e) => {
                   e.target.style.color = "#EC008C";
              }}
              onMouseLeave={(e) => {
                e.target.style.color = "#ffff";
              }}
                onClick={handleResendOtp}
                // onKeyDown={(e) => handleKeyboardNavigation(e)}
                // onKeyDown={(e) => {
                // if (e.key === "Enter") {
                //   setOtp(["", "", "", "", "", ""]);
                //   handleResendOtp();
                // }
                // }}
              >
                <Translate langKey={"Resend"} />
              </button>
            {/* </CustomButton> */}
          </div>
        ) : (
          <div className="resend-section">
             <p>
              <Translate langKey={"Resend-OTP-in"} />  {timer}s
            </p>
            {/* <CustomButton> */}
             
          
          </div>
        )}
      </div>
      {/* Inline CSS */}
      <style>
        {`
          .otp-container {
            text-align: center;
            color: rgba(255, 255, 255, 1);
          }

          h2 {
            margin-bottom: 10px;
            font-family: Anek Latin;
            font-weight: 700;
            font-size:38px
          }

          p {
            margin-bottom: 20px;
            font-family: Anek Latin;
            font-weight: 400;
            font-size:28px
          }

          .otp-inputs {
            display: flex;
            justify-content: center;
            margin-bottom: 20px;
            gap: 1px;
          }

          .error-message {
            color: #EC008C;
            font-size: 20px;
            margin-top: 10px;
            margin:0;
            padding:0;
          }

          .otp-box {
            width: 4.4rem;
            height: 4.4rem;
            margin: 0 5px;
            font-size: 24px;
            text-align: center;
            border: 1px solid rgba(255, 255, 255, 1);
            background-color: #0E1653;
            color: white;
            outline: none;
            border-radius: 8px;
          }

          .keyboard {
            display: grid;
            grid-template-columns: repeat(3, 0fr);
            gap: 10px;
            justify-content: center;
            position:relative;
            top:2rem;
          }

          .resendotptimer {
            font-family:Anek Latin;
            font-weight: 400;
            font-size:16px;
            color:rgba(151, 151, 151, 1);
          }

          .key {
            width: 15vh;
            height: 6vh;
            font-size: 20px;
            color: white;
            background-color: #0E1653;
            border: none;
            cursor: pointer;
            outline: none;
            text-align: center;
          }

          .key.focused {
            background-color: #EC008C;
          }

          .resend-section {
            display: inline-flex;
            top:3rem;
          }

          .resend-section p{
            font-family:Anek Latin;
            font-weight:400;
            font-size:16px;
            color:rgba(151, 151, 151, 1);
          }

          .key:focus {
            outline: none;
          }

          .resend-otp {
            // margin-top: 15px;
            font-size: 14px;
            color: gray;
            position:relative;
            top:4rem;
          }

          .resend-button {
            background: none;
            border: none;
            cursor: pointer;
            font-size: 14px;
            outline: none;
            // margin-bottom:2px;
            font-family:Anek Latin;
            font-weight:600;
            font-size:16px;
            color:rgba(151, 151, 151, 1);
            position: relative;
            top: -0.12rem;
            text-decoration:underline
          }
          
        `}
      </style>
    </div>
  );
};

export default OtpVerification;
